import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-area-select";

function ProjectArea(props) {
  const map = useMap();
  map.invalidateSize(true);
  map.getRenderer(map).options.padding = 200;

  useEffect(() => {
    const maxLat = 90; // Maximum latitude
    const minLat = -90; // Minimum latitude
    const maxLng = Infinity; // Maximum longitude
    const minLng = -Infinity; // Minimum longitude

    // Create a LatLngBounds object to represent the bounding box
    const bounds = L.latLngBounds(
      L.latLng(minLat, minLng), // Southwest corner
      L.latLng(maxLat, maxLng) // Northeast corner
    );

    // Set maximum bounds for the map
    map.setMaxBounds(bounds);

    map.eachLayer((layer) => {
      if (layer instanceof L.Rectangle || layer instanceof L.CircleMarker || layer instanceof L.Polyline) {
        map.removeLayer(layer);
      }
    });

    let location = [
      [props.meta.northLatitude, props.meta.eastLongitude],
      [props.meta.southLatitude, props.meta.westLongitude],
    ];

    if (props.meta.eastLongitude !== undefined) {
      map.eachLayer((layer) => {
        if (layer instanceof L.rectangle) {
          map.removeLayer(layer);
        }
      });

      L.tileLayer(
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}'
      ).addTo(map);
      map.panTo(new L.LatLng(props.meta.northLatitude, props.meta.eastLongitude));

      const newRectangle = L.rectangle(location, {
        color: "blue",
        weight: 1,
      }).addTo(map);

      let antimeridianLocation = [
        [props.meta.northLatitude, props.meta.eastLongitude + 360],
        [props.meta.southLatitude, props.meta.westLongitude + 360],
      ]
      const antimeridianRectangle = L.rectangle(antimeridianLocation, {
        color: "blue",
        weight: 1,
      }).addTo(map);

      let negativeAntiLocation = [
        [props.meta.northLatitude, props.meta.eastLongitude - 360],
        [props.meta.southLatitude, props.meta.westLongitude - 360],
      ]
      const negativeAntiRectangle = L.rectangle(negativeAntiLocation, {
        color: "blue",
        weight: 1,
      }).addTo(map);


      map.fitBounds(newRectangle.getBounds());
      return () => {
        map.removeLayer(newRectangle);
      };
    }
  }, [props]);

  const bounds = map.getBounds().pad(-0.25);

  map.selectArea.setValidate((layerPoint) => {
    return bounds.contains(this._map.layerPointToLatLng(layerPoint));
  });

  map.selectArea.setValidate();
  return null;
}

export default ProjectArea;
